function getCategories(selectedGroups, catalogCategories) {
  var result = [];

  catalogCategories.forEach((category) => {
    if (Object.hasOwn(category, "filteredL1")) {
      if (selectedGroups.includes(category.filteredL1[0].id)) {
        result.push({ key: category.id, value: category.name });
      }
    } else if (Object.hasOwn(category, "filteredL2")) {
      if (selectedGroups.includes(category.filteredL2[0].id)) {
        result.push({ key: category.id, value: category.name });
      }
    } else {
      result.push({ key: category.id, value: category.name });
    }
  });
  return result;
}

export default getCategories;
